/**
 * Canvas Settings.
 *
 * Deliberately thin. The page is a shared destination owned by
 * canvas.navigation, and every section on it is an ordinary accordion whose
 * heading reports its own state - so expandExistingSection opens the tab and
 * the panel on the way to a field, and nothing here has to know that any
 * particular section exists.
 *
 * There is nothing to resolve either: one Canvas has one of each of these
 * settings. That is why this plugin declares no resolvers, filters or focus
 * handlers, where Site and Access Point declare all three.
 */
const systemSettingsPlugin = {
	id: 'system_settings',
	version: 1,
	commandVersion: 1,
	resource: 'system_settings',
	operations: ['options', 'configure'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['settings.dashboard'],
	},
};

export default systemSettingsPlugin;
